import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Stagger from './Stagger';
import Reveal from './Reveal';

const images = [
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.30.40.jpeg?alt=media&token=bd79b1e2-4a4f-4b52-88f0-e080148a5e09',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.38.23.jpeg?alt=media&token=f920e38d-af7f-42d1-946f-b182b274a739',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.39.46.jpeg?alt=media&token=65f0be11-4ea9-4bf9-93ea-6f7726c3c4d5',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.43.56.jpeg?alt=media&token=ddd79527-431a-4fa2-ac36-0337eb582fc2',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.44.46.jpeg?alt=media&token=73f5ecf4-3388-4f35-b827-d40350acc9dd',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.45.43.jpeg?alt=media&token=4a059fcd-754b-43cd-94d6-0607161ae4df',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.46.23.jpeg?alt=media&token=fa86832e-a64c-4852-8a70-d5dcf23d96ec',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.46.55.jpeg?alt=media&token=20d73060-53b9-4452-82e1-168c105cc5dc',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.49.00.jpeg?alt=media&token=fac96762-97db-46b7-8993-2e2aec918208',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.50.40.jpeg?alt=media&token=72c1c32e-3223-4a9e-89a9-ee30338c588c',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.51.11.jpeg?alt=media&token=939de601-ecc9-44fa-b744-d032f87081e0',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.52.11.jpeg?alt=media&token=88e6e546-bbd8-436b-a961-5458f7001be0',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.52.45.jpeg?alt=media&token=e55692bd-215d-425f-9c97-7b1637b5c6ee',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.53.37.jpeg?alt=media&token=2286df7c-5e54-459a-bbe8-d722c1bd794a',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.54.35.jpeg?alt=media&token=7d0ae85f-128a-431d-a393-99660eecd800',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.54.50.jpeg?alt=media&token=37916834-52c2-4899-b618-f87f39de52e5',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.55.06.jpeg?alt=media&token=6da06981-0b51-4dca-8c4d-ddbee08fd164',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.57.11.jpeg?alt=media&token=54176a1a-d74b-443e-b3a5-bdbff53aefb2',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.57.26.jpeg?alt=media&token=3284183a-30ea-4676-9b85-a962efa3df5a',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.58.09.jpeg?alt=media&token=bce1bdfc-f924-4173-9b6c-74b9b1842159',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.59.14.jpeg?alt=media&token=d053c029-dbf9-4977-b98c-8b063d5c88af',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2009.59.48.jpeg?alt=media&token=dc34af29-817a-400a-aada-b6b1442efc7a',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.00.25.jpeg?alt=media&token=172ab137-6a5b-4250-b0d0-6272b95bf6e9',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.01.17.jpeg?alt=media&token=73713cc0-0b4a-4c6e-bdab-8eaeec438e39',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.02.16.jpeg?alt=media&token=33dd4400-65b3-4472-bb69-3eec7fd8714f',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.02.50.jpeg?alt=media&token=e98caf56-c96f-4498-b32f-f2dad5cc3ccf',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.03.49.jpeg?alt=media&token=d9807256-7919-4ba0-b674-6f64dda73cc4',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.04.22.jpeg?alt=media&token=ae7c7f6c-4ecc-4ff7-bd83-8e57d36f1880',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.04.48.jpeg?alt=media&token=d37b4ab3-521f-43e6-adb5-53f6c671abb0',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.05.56.jpeg?alt=media&token=021bfb36-1fb3-4d2a-9bfc-6abfe9ec771f',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.07.24.jpeg?alt=media&token=5e0540f7-fa29-4fa8-a95d-9e53d60db2e2',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.08.07.jpeg?alt=media&token=dc7bd047-b0ef-4e52-9ded-cf762aa5711f',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.09.21.jpeg?alt=media&token=ae1eb1b3-939c-4266-b246-2322ec3ed63d',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.10.42.jpeg?alt=media&token=8e850d01-4208-4386-bfe0-5598db449bd5',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.10.47.jpeg?alt=media&token=ffdd364a-4512-47b1-9704-01973e02d405',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.10.58.jpeg?alt=media&token=dc671fff-2a7c-42a6-ad4b-6014640bf275',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.11.43.jpeg?alt=media&token=4cdc5df0-f0b1-450c-8617-eaa9954a64a7',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.12.18.jpeg?alt=media&token=0da824e4-d70f-4be9-b65c-d8d37e8ff440',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.13.17.jpeg?alt=media&token=8541d261-da86-4b58-8547-3952072b20f0',
  'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FWhatsApp%20Image%202025-11-12%20at%2010.14.04.jpeg?alt=media&token=05a22790-7867-4468-9424-0f4faef339c3',
];

export default function Gallery() {
  // Filtrar imágenes vacías
  const validImages = images.filter(img => img && img.trim() !== '');
  const totalImages = validImages.length;
  const displayedImages = 5; // 1 grande + 4 pequeñas (desktop)
  const remainingCountDesktop = totalImages - displayedImages;
  const remainingCountMobile = totalImages - 1; // Solo 1 imagen en mobile

  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const [currentImageLoading, setCurrentImageLoading] = useState(true);
  const swiperRef = useRef(null);

  const handleOpen = (index) => {
    setCurrentIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % totalImages);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + totalImages) % totalImages);
  };

  // Precargar las primeras 5 imágenes del grid principal
  useEffect(() => {
    const preloadImages = [];
    for (let i = 0; i < Math.min(5, validImages.length); i++) {
      const img = new Image();
      img.src = validImages[i];
      preloadImages.push(img);
    }
  }, [validImages]);

  // Precargar imágenes adyacentes cuando cambia el índice en el modal
  useEffect(() => {
    if (!open) return;

    const preloadAdjacent = () => {
      const indicesToPreload = [
        (currentIndex - 1 + totalImages) % totalImages,
        (currentIndex + 1) % totalImages,
        (currentIndex - 2 + totalImages) % totalImages,
        (currentIndex + 2) % totalImages,
      ];

      indicesToPreload.forEach((index) => {
        if (!loadedImages.has(index)) {
          const img = new Image();
          img.src = validImages[index];
          img.onload = () => {
            setLoadedImages((prev) => new Set([...prev, index]));
          };
        }
      });
    };

    preloadAdjacent();
  }, [open, currentIndex, totalImages, validImages, loadedImages]);

  // Verificar si la imagen ya está cargada cuando cambia el índice
  useEffect(() => {
    if (open) {
      // Si ya la marcamos como cargada, no mostrar loading
      if (loadedImages.has(currentIndex)) {
        setCurrentImageLoading(false);
        return;
      }

      // Verificar si la imagen ya está en cache del navegador ANTES de mostrar loading
      const img = new Image();
      const imageUrl = validImages[currentIndex];
      
      // Verificar cache primero (sincrónico)
      img.src = imageUrl;
      
      // Si ya está completa (en cache), no mostrar loading
      if (img.complete && img.naturalWidth > 0) {
        setCurrentImageLoading(false);
        setLoadedImages((prev) => new Set([...prev, currentIndex]));
        return;
      }
      
      // Solo si no está en cache, mostrar loading y configurar handlers
      setCurrentImageLoading(true);
      
      img.onload = () => {
        setCurrentImageLoading(false);
        setLoadedImages((prev) => new Set([...prev, currentIndex]));
      };
      
      img.onerror = () => {
        setCurrentImageLoading(false);
      };
    }
  }, [open, currentIndex, validImages, loadedImages]);

  // Desplazar el swiper de miniaturas cuando cambia la imagen actual
  useEffect(() => {
    if (open && swiperRef.current) {
      swiperRef.current.slideTo(currentIndex);
    }
  }, [open, currentIndex]);

  // Navegación con teclado
  useEffect(() => {
    if (!open) return;
    
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowRight') {
        setCurrentIndex((prev) => (prev + 1) % totalImages);
      }
      if (e.key === 'ArrowLeft') {
        setCurrentIndex((prev) => (prev - 1 + totalImages) % totalImages);
      }
      if (e.key === 'Escape') {
        setOpen(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [open, totalImages]);

  const renderImageBox = (img, index, gridArea, isLarge = false) => (
    <Box
      key={index}
      sx={{
        ...(gridArea !== 'auto' && { gridArea: { xs: gridArea, md: gridArea } }),
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: 2,
        cursor: 'pointer',
        height: { xs: isLarge ? 240 : 160, md: isLarge ? '100%' : '200px' },
        position: 'relative',
        '&:hover': { transform: 'scale(1.03)' },
        transition: 'transform 0.2s',
        backgroundColor: '#f0f0f0',
      }}
      onClick={() => handleOpen(index)}
    >
      <img
        src={img}
        alt={`Galería ${index + 1}`}
        loading={index < 5 ? 'eager' : 'lazy'}
        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
    </Box>
  );


  return (
    <Box sx={{ py: 8, background: 'transparent' }}>
      <Box maxWidth={1200} mx="auto" px={2}>
        <Stagger baseDelay={0} step={110} variants={['zoom', 'fade-up', 'slide-left']} distance={16}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
            Galería
          </Typography>
          <Typography
            variant="subtitle1"
            sx={{
              mb: 3,
              color: 'text.secondary',
              borderBottom: 3,
              borderColor: 'warning.main',
              display: 'inline-block',
              pb: 0.5,
            }}
          >
            Explorá La Granja a través de imágenes que capturan su belleza natural y cultural.
          </Typography>
          <Box
            sx={{
              display: 'grid',
              gap: 2,
              mt: 4,
              gridTemplateColumns: { xs: '1fr', md: '2fr 1fr 1fr' },
              gridTemplateRows: { xs: 'none', md: 'repeat(2, 200px)' },
              gridTemplateAreas: {
                xs: '"img0"',
                md: '"img0 smallGrid smallGrid" "img0 smallGrid smallGrid"',
              },
            }}
          >
          {/* Imagen grande con overlay +X en mobile */}
          <Box
            sx={{
              gridArea: 'img0',
              position: 'relative',
            }}
          >
            <Reveal className="reveal-fill" delay={120} variant="zoom" distance={14}>
              {renderImageBox(validImages[0], 0, 'auto', true)}
            </Reveal>
            {/* Overlay +X sobre la imagen solo en mobile */}
            {remainingCountMobile > 0 && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: 2,
                  cursor: 'pointer',
                  background: 'rgba(0, 0, 0, 0.5)',
                  backdropFilter: 'blur(2px)',
                  display: { xs: 'flex', md: 'none' },
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 2,
                  '&:hover': {
                    background: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(3px)',
                  },
                  transition: 'all 0.3s ease',
                }}
                onClick={() => handleOpen(1)}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    color: 'white',
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 700,
                      fontSize: '2rem',
                      mb: 0.5,
                      textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                    }}
                  >
                    +{remainingCountMobile}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ 
                      fontSize: '0.85rem',
                      textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                    }}
                  >
                    Ver más fotos
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
          
          {/* Contenedor para las 4 imágenes pequeñas con overlay (solo desktop) */}
          <Box
            sx={{
              gridArea: 'smallGrid',
              display: { xs: 'none', md: 'grid' },
              gap: 2,
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: 'repeat(2, 200px)',
              position: 'relative',
            }}
          >
            <Reveal delay={200} variant="slide-left" distance={18}>
              {renderImageBox(validImages[1], 1, 'auto')}
            </Reveal>
            <Reveal delay={280} variant="fade-up" distance={18}>
              {renderImageBox(validImages[2], 2, 'auto')}
            </Reveal>
            <Reveal delay={360} variant="slide-right" distance={18}>
              {renderImageBox(validImages[3], 3, 'auto')}
            </Reveal>
            <Box sx={{ position: 'relative' }}>
              <Reveal delay={440} variant="zoom" distance={16}>
                {renderImageBox(validImages[4], 4, 'auto')}
              </Reveal>
              {/* Overlay transparente con +X solo sobre la última imagen (abajo a la derecha) - solo desktop */}
              {remainingCountDesktop > 0 && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: 2,
                    cursor: 'pointer',
                    background: 'rgba(0, 0, 0, 0.5)',
                    backdropFilter: 'blur(2px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2,
                    '&:hover': {
                      background: 'rgba(0, 0, 0, 0.6)',
                      backdropFilter: 'blur(3px)',
                    },
                    transition: 'all 0.3s ease',
                  }}
                  onClick={() => handleOpen(displayedImages)}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      color: 'white',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 700,
                        fontSize: '3rem',
                        mb: 1,
                        textShadow: '0 2px 8px rgba(0,0,0,0.5)',
                      }}
                    >
                      +{remainingCountDesktop}
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        fontSize: '1rem',
                        textShadow: '0 2px 4px rgba(0,0,0,0.5)',
                      }}
                    >
                      Ver más fotos
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        </Stagger>

        {/* Modal completo con navegación */}
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            sx: {
              bgcolor: 'rgba(0,0,0,0.85)',
              maxHeight: '95vh',
              m: 1,
              boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: 'rgba(0,0,0,0.7)',
            },
          }}
        >
          <Box sx={{ position: 'relative', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header con contador y botón cerrar */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 10,
                background: 'linear-gradient(to bottom, rgba(0,0,0,0.4), transparent)',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontWeight: 600,
                }}
              >
                {currentIndex + 1} / {totalImages}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  color: 'white',
                  background: 'rgba(0,0,0,0.3)',
                  '&:hover': { background: 'rgba(0,0,0,0.5)' },
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Imagen principal */}
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                p: { xs: 2, md: 4 },
                pt: { xs: 8, md: 10 },
                pb: { xs: 8, md: 10 },
                minHeight: 0,
              }}
            >
              {/* Botón anterior */}
              <IconButton
                onClick={handlePrev}
                sx={{
                  position: 'absolute',
                  left: { xs: 8, md: 16 },
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  background: 'rgba(0,0,0,0.5)',
                  '&:hover': { background: 'rgba(0,0,0,0.7)' },
                  zIndex: 5,
                }}
              >
                <ArrowBackIosIcon />
              </IconButton>

              {/* Imagen con placeholder mientras carga */}
              {currentImageLoading && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 60,
                    height: 60,
                    border: '3px solid rgba(255,255,255,0.3)',
                    borderTop: '3px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    '@keyframes spin': {
                      '0%': { transform: 'translate(-50%, -50%) rotate(0deg)' },
                      '100%': { transform: 'translate(-50%, -50%) rotate(360deg)' },
                    },
                  }}
                />
              )}
              <Box
                component="img"
                src={validImages[currentIndex]}
                alt={`Galería ${currentIndex + 1}`}
                sx={{
                  maxWidth: '100%',
                  maxHeight: { xs: '50vh', md: '60vh' },
                  objectFit: 'contain',
                  borderRadius: 2,
                  opacity: currentImageLoading ? 0 : 1,
                  transition: 'opacity 0.3s ease',
                }}
                onLoad={(e) => {
                  const img = e.target;
                  if (img.complete && img.naturalWidth > 0) {
                    setCurrentImageLoading(false);
                    setLoadedImages((prev) => new Set([...prev, currentIndex]));
                  }
                }}
              />

              {/* Botón siguiente */}
              <IconButton
                onClick={handleNext}
                sx={{
                  position: 'absolute',
                  right: { xs: 8, md: 16 },
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'white',
                  background: 'rgba(0,0,0,0.5)',
                  '&:hover': { background: 'rgba(0,0,0,0.7)' },
                  zIndex: 5,
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </Box>

            {/* Miniaturas con Swiper */}
            <Box
              sx={{
                p: 2,
                background: 'linear-gradient(to top, rgba(0,0,0,0.4), transparent)',
                position: 'relative',
              }}
            >
              <style>{`
                .gallery-thumbnails .swiper-button-next,
                .gallery-thumbnails .swiper-button-prev {
                  color: white;
                  background: rgba(0,0,0,0.5);
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  margin-top: 0;
                  top: 50%;
                  transform: translateY(-50%);
                }
                .gallery-thumbnails .swiper-button-next:after,
                .gallery-thumbnails .swiper-button-prev:after {
                  font-size: 16px;
                }
                .gallery-thumbnails .swiper-button-next:hover,
                .gallery-thumbnails .swiper-button-prev:hover {
                  background: rgba(0,0,0,0.7);
                }
                .gallery-thumbnails .swiper-button-disabled {
                  opacity: 0.3;
                }
              `}</style>
              <Swiper
                modules={[Navigation]}
                navigation={true}
                slidesPerView="auto"
                spaceBetween={8}
                className="gallery-thumbnails"
                onSwiper={(swiper) => {
                  swiperRef.current = swiper;
                  // Desplazar a la imagen actual cuando se inicializa
                  if (open) {
                    swiper.slideTo(currentIndex);
                  }
                }}
                style={{
                  padding: '0 40px',
                }}
              >
                {validImages.map((img, index) => (
                  <SwiperSlide
                    key={index}
                    style={{
                      width: 'auto',
                      cursor: 'pointer',
                    }}
                    onClick={() => setCurrentIndex(index)}
                  >
                    <Box
                      sx={{
                        width: 80,
                        height: 80,
                        borderRadius: 1,
                        overflow: 'hidden',
                        border: currentIndex === index ? '3px solid #1976d2' : '3px solid transparent',
                        opacity: currentIndex === index ? 1 : 0.7,
                        '&:hover': {
                          opacity: 1,
                          transform: 'scale(1.1)',
                        },
                        transition: 'all 0.2s',
                        position: 'relative',
                      }}
                    >
                      <img
                        src={img}
                        alt={`Miniatura ${index + 1}`}
                        loading={index < 10 ? 'eager' : 'lazy'}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          display: 'block',
                        }}
                      />
                      {/* Número de foto en miniatura */}
                      <Box
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          background: 'linear-gradient(to top, rgba(0,0,0,0.6), transparent)',
                          color: 'white',
                          fontSize: '0.7rem',
                          fontWeight: 600,
                          textAlign: 'center',
                          py: 0.5,
                        }}
                      >
                        {index + 1}
                      </Box>
                    </Box>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </Box>
        </Dialog>
      </Box>
    </Box>
  );
}
